import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { Add, CheckBox, Delete } from "@mui/icons-material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";
import {
  validateNumber,
  validatePercentage,
} from "../../../../utils/validateFields";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";
import { fixedPercentage } from "../../../../utils/common";

const DynamicTablePercent = memo(
  ({
    inputData,
    subHeading,
    tables,
    setTables,
    errors,
    setErrors,
    data,
    letter,
    disabled,
    hide,
    field1
  }) => {
    useEffect(() => {
      setTables(
        inputData?.map((section) => ({
          fieldName: section.fieldName,
          rows: data?.[section.fieldName] || [{}],
        }))
      );
    }, [data]);
    const [fieldToRemove, setFieldToRemove] = React.useState({
      tableIndex: null,
      rowIndex: null,
    });
    const [snackOpen, setsnackOpen] = useState({
      open: false,
      message: "",
      severity: "",
    });
    const [openDialog, setOpenDialog] = React.useState(false);
    const [isFilled, setIsFilled] = useState({});

    const handleAddRow = (tableIndex) => {
      setTables((prev) => {
        const newTables = [...prev];
        newTables[tableIndex].rows.push({});
        return newTables;
      });
    };

    const handleRemoveRow = (tableIndex, rowIndex) => {
      setTables((prev) => {
        const newTables = [...prev];
        if (
          Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
        ) {
          setOpenDialog(true);
          setFieldToRemove({ tableIndex, rowIndex });
          return newTables;
        }

        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    };

    const cancelRemoveRow = () => {
      setOpenDialog(false);
    };

    const confirmRemoveRow = () => {
      if (fieldToRemove) {
        const { tableIndex, rowIndex } = fieldToRemove;
        setTables((prev) => {
          const newTables = [...prev];
          newTables[tableIndex].rows.splice(rowIndex, 1);
          return newTables;
        });
      }
      setOpenDialog(false);
    };

    

    
    const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
      // Allow clearing input completely
      if((fieldName==="goveranceBody"  || fieldName==="antiCorruption") && value==="")
        {        const updatedTables = [...tables];
        //   updatedTables[tableIndex].rows[rowIndex]["goveranceBody"]="";
        //  updatedTables[tableIndex].rows[rowIndex]["antiCorruption"]="";
         updatedTables[tableIndex].rows[rowIndex]["infored"] = "";
        }  
        if (value === "") {
        const updatedTables = [...tables];
        updatedTables[tableIndex].rows[rowIndex][fieldName] = "";
       if (fieldName==="goveranceBody"  || fieldName==="antiCorruption") 
        updatedTables[tableIndex].rows[rowIndex]["infored"] = "";
        setTables(updatedTables);
        return;
      }
    
      // Validate input type
      if (type === "percentage" && !validatePercentage(value)) return;
      if (type === "number" && !validateNumber(value)) return;
    
      // Clone the tables array
      const updatedTables = [...tables];

      console.log(fieldName,value,updatedTables[tableIndex].rows[rowIndex],"value")
    
         
      
        updatedTables[tableIndex].rows[rowIndex][fieldName] = value;
    
      // Retrieve values from the row
      const totalMembers = updatedTables[tableIndex].rows[rowIndex]["goveranceBody"];
      const antiCorruption = updatedTables[tableIndex].rows[rowIndex]["antiCorruption"];
    
      // Clone errors so we can update them
      const updatedErrors = { ...errors };
    
      // Check if both fields have valid entries before calculating
      if (totalMembers && antiCorruption !== undefined && antiCorruption !== "") {
        if (parseFloat(antiCorruption) > parseFloat(totalMembers)) {
          updatedTables[tableIndex].rows[rowIndex]["infored"] = "";
          updatedErrors[tableIndex] = {
            ...updatedErrors[tableIndex],
            [rowIndex]: {
              ...updatedErrors[tableIndex]?.[rowIndex],
              antiCorruption: "Anti corruption cannot be greater than governance body.",
            },
          };
        } else {
          // Remove existing errors
          if (updatedErrors[tableIndex]?.[rowIndex]?.antiCorruption) {
            const { antiCorruption, ...rest } = updatedErrors[tableIndex][rowIndex];
            updatedErrors[tableIndex][rowIndex] = rest;
            if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
              delete updatedErrors[tableIndex][rowIndex];
            }
            if (Object.keys(updatedErrors[tableIndex]).length === 0) {
              delete updatedErrors[tableIndex];
            }
          }
    
          // Calculate percentage
          const percentage = (parseFloat(antiCorruption) / parseFloat(totalMembers)) * 100;
          updatedTables[tableIndex].rows[rowIndex]["infored"] = fixedPercentage(percentage);
        }
      
      } else {
        // Clear percentage field if one input is missing
        updatedTables[tableIndex].rows[rowIndex]["infored"] = "";
      }
      
      // Update state
      setErrors(updatedErrors);
      setTables(updatedTables);
      checkIfAdded();
    
    };
    
    useEffect(() => {
      checkIfAdded();
    }, [tables, inputData]); 

    const checkIfAdded = () => {
      tables.forEach((table, tableIndex) => {
        const rows = table?.rows || [];
        const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; 
        const filteredLastRow = Object.fromEntries(
          Object.entries(lastRow).filter(([key]) => key !== "_id")
        );

        const optionalLength = inputData?.[tableIndex]?.fields?.filter(
          (el) => el?.optional
        )?.length;
        console.log(optionalLength, "option");
        // Check if lastRow is fully filled
        const isComplete =
          Object.keys(filteredLastRow).length >=
            (inputData?.[tableIndex]?.fields?.length - optionalLength || 0) &&
          Object.values(filteredLastRow)?.every(
            (val) =>
              val !== undefined &&
              val !== "" &&
              val !== null &&
              val?.length !== 0
          );
        console.log("complte", lastRow, isComplete);
        setIsFilled((prevState) => ({
          ...prevState,
          [tableIndex]: !isComplete, // true if incomplete, false if fully filled
        }));
      });
    };

    return (
      <Box sx={{ mt: "2rem" }}>
        <DeleteRowDialog
          {...{ openDialog, cancelRemoveRow, confirmRemoveRow }}
        />
        {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              {section?.letter && (
                <p className={style.ques_heading}>{section.letter}</p>
              )}
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",

                  textIndent: "-1rem",
                  paddingLeft: "1rem",
                }}
                gutterBottom
              >
                {section.title}
              </Typography>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                ml: 2,
                width: "98%",
                borderRadius: "10px",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                    console.log(row, "checking row");
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          
                          "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "30px",
                            
                          },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center",
                            width: "8%",}}>{rowIndex + 1}.</TableCell>
                        {section?.fields?.map((field, cellIndex) => (
                          <TableCell
                            key={field?.fieldName}
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              backgroundColor:
                                cellIndex === section.fields.length - 1
                                  ? "#EFEFEF"
                                  : "transparent", // Apply background color to the last column
                            }}
                          >
                            {field.type === "select" ? (
                              <Select
                                multiple={field?.multiselect}
                                value={
                                  field.multiselect
                                    ? row[field?.fieldName] || []
                                    : row[field?.fieldName] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                displayEmpty
                                fullWidth
                                size="small"
                                sx={{
                                  border: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}
                                renderValue={(selected) =>
                                  field.multiselect && selected.length > 0
                                    ? selected.join(", ")
                                    : field.placeholder || "Select"
                                }
                              >
                                <MenuItem value={""} disabled>
                                  {field.placeholder || "Select"}
                                </MenuItem>
                                {field.options?.map((option, idx) => (
                                  <MenuItem key={idx} value={option}>
                                    {field.multiselect ? (
                                      <>
                                        <Checkbox
                                          checked={
                                            row[field.fieldName]?.includes(
                                              option
                                            ) || false
                                          }
                                          size="small"
                                        />
                                        {option}
                                      </>
                                    ) : (
                                      option
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : field.type === "radio" ? (
                              <Box sx={{ display: "flex" }}>
                                <FormControl sx={{ my: 1, display: "flex" }}>
                                  <RadioGroup
                                    row
                                    value={row[field.fieldName] || "Yes"}
                                    onChange={(e) =>
                                      handleInputChange(
                                        tableIndex,
                                        rowIndex,
                                        field.fieldName,
                                        e.target.value,
                                        field.type
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      control={<Radio />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            ) : (
                              <TextField
                                placeholder={field.placeholder}
                                type={field.type}
                                value={row[field.fieldName] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                multiline
                                // rows={1}
                                sx={{
                                  width: "100%",
                                  py: "0.5rem",
                                  "& .MuiInputBase-root": {
                                    overflowY: "auto",
                                    cursor: "default", // default cursor
                                  },
                                  "& .MuiInputBase-root:hover": {
                                    cursor: "pointer", // pointer cursor on hover
                                  },
                                  "& .MuiInput-underline:before": {
                                    borderBottom: "none", // Remove the underline before focusing
                                  },
                                  "& .MuiInput-underline:after": {
                                    borderBottom: "none", // Remove the underline after focusing
                                  },
                                  "& .MuiInput-underline:hover:before": {
                                    borderBottom: "none", // Remove underline on hover
                                  },
                                }}
                                size="small"
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                                disabled={field1===field?.fieldName ||disabled}
                              />
                            )}
                          </TableCell>
                        ))}
                        <TableCell>
                          <IconButton
                            // disabled={rowIndex === 0}
                            disabled={tables[tableIndex]?.rows?.length === 1 || disabled}
                            onClick={() =>
                              handleRemoveRow(tableIndex, rowIndex)
                            }
                            color="error"
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 1,ml:2 }}>
              {Object.keys(errors).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
            </Box>
            {/* Add row button */}
            {!hide && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-0.5rem",
              }}
            >
              <Button
                disabled={isFilled?.[tableIndex] || disabled}
                endIcon={<Add />}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  marginTop: "1rem",
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
)}

            {/* Dynamic error messages for missing fields */}
          </div>
        ))}
      </Box>
    );
  }
);

export default DynamicTablePercent;
